// Minimal client-side SEO meta injector (title + OG/Twitter tags).
export function applySeo({ title, description, image, type = "article", url }) {
  const setMeta = (attr, key, val) => {
    if (!val) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
    el.setAttribute("content", val);
  };
  const prevTitle = document.title;
  if (title) document.title = title;
  const desc = (description || "").slice(0, 160);
  setMeta("name", "description", desc);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", desc);
  setMeta("property", "og:type", type);
  setMeta("property", "og:url", url || window.location.href);
  setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
  if (image) setMeta("property", "og:image", image);
  return () => { document.title = prevTitle; };
}
